import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import COMPONENT_LIST_SET_DELETE from '../mutations/COMPONENT_LIST_SET_DELETE';
  
const useComponentListSetDelete = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( COMPONENT_LIST_SET_DELETE );

    const handleCLDelete = async ( id ) => {
        setIsDeleting( true );
        
        try {
            const response = await deleteMutation( { variables: { input: { componentListSetId: id }  } } );
            setIsDeleting( false ); 
            
            if ( response.data.deleteComponentListSet ) {
                return true;
            } else {
                return false;
            }
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting component list!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteComponentList: handleCLDelete
        };
    }, [ isDeleting ] );
};

export default useComponentListSetDelete;
